import {
	AddonProvider,
	AxiosConfig,
	AxiosRefreshConfig,
	BlockProvider,
	FCC,
	ImageLibraryProvider,
	UserPermissionProvider,
	useDynamicConfig,
} from "@dgs/core";
import { GlobalContactViewProvider } from "./contactViews/global/GlobalContactViewProvider";
import { JarvisBlockMetaProvider } from "./contentManagement/JarvisBlockMetaProvider";
import { GlobalTenantProvider } from "./tenants/global/GlobalTenantProvider";

export const ContentProviders: FCC = ({ children }) => {
	const { apiUrl, addons } = useDynamicConfig();

	return (
		<AddonProvider addons={addons}>
			<AxiosConfig apiUrl={apiUrl} />
			<AxiosRefreshConfig apiUrl={apiUrl}>
				<UserPermissionProvider>
					{(isInitialized) =>
						isInitialized && (
							<GlobalContactViewProvider>
								<GlobalTenantProvider>
									<ImageLibraryProvider moduleUrl={`${apiUrl}/images`}>
										<JarvisBlockMetaProvider>
											<BlockProvider>{children}</BlockProvider>
										</JarvisBlockMetaProvider>
									</ImageLibraryProvider>
								</GlobalTenantProvider>
							</GlobalContactViewProvider>
						)
					}
				</UserPermissionProvider>
			</AxiosRefreshConfig>
		</AddonProvider>
	);
};
